/*
 * House of Daisy — a form that refuses says why (Phase six, E3).
 *
 * On a submit with problems: a summary at the top ("2 things to fix"), one
 * link per problem that takes her to the field, and under each field a line
 * that names the rule. A wedding date in the past offers the same day in the
 * coming year as a button. Nothing she typed is cleared.
 *
 * The checks are the page's own (hod-booking.js, hod-tell-us); this file
 * only shows them. Copy comes from snippets/hod-form-check (hod.form_check.*).
 *
 *   hodFormCheck.show(form, [{ field, message, short, container?, fix? }])
 *   hodFormCheck.clear(form)
 *   hodFormCheck.phone(value, code)   -> null, or { message, short }
 *   hodFormCheck.pastDate(input)      -> null, or a problem with its fix
 */
(function () {
  if (window.hodFormCheck) return;

  var copy = null;
  var uid = 0;

  function decode(s) {
    var t = document.createElement('textarea');
    t.innerHTML = s;
    return t.value;
  }

  function getCopy() {
    if (copy) return copy;
    copy = {};
    var node = document.querySelector('[data-hod-form-check-copy]');
    if (!node) return copy;
    try {
      var raw = JSON.parse(node.textContent);
      Object.keys(raw).forEach(function (k) {
        copy[k] = typeof raw[k] === 'string' ? decode(raw[k]) : raw[k];
      });
    } catch (e) {}
    return copy;
  }

  function fill(text, vars) {
    return String(text || '').replace(/\[(\w+)\]/g, function (_, k) {
      return vars[k] != null ? vars[k] : '';
    });
  }

  function labelFor(field) {
    if (field.dataset && field.dataset.hodCheckLabel) return field.dataset.hodCheckLabel;
    var label = field.id && document.querySelector('label[for="' + field.id + '"]');
    if (label) return label.textContent.trim();
    var legend = field.closest('fieldset') && field.closest('fieldset').querySelector('legend');
    return legend ? legend.textContent.trim() : field.name || '';
  }

  function containerFor(field) {
    return field.closest('[data-hod-check-field], .hod-field, .hod-tell__field') || field.parentNode;
  }

  function markInvalid(field, errorId) {
    field.setAttribute('aria-invalid', 'true');
    if (!field.hasAttribute('data-hod-check-described')) {
      field.setAttribute('data-hod-check-described', field.getAttribute('aria-describedby') || '');
    }
    var before = field.getAttribute('data-hod-check-described');
    field.setAttribute('aria-describedby', (before ? before + ' ' : '') + errorId);
  }

  function unmark(field) {
    field.removeAttribute('aria-invalid');
    if (field.hasAttribute('data-hod-check-described')) {
      var before = field.getAttribute('data-hod-check-described');
      if (before) field.setAttribute('aria-describedby', before);
      else field.removeAttribute('aria-describedby');
      field.removeAttribute('data-hod-check-described');
    }
  }

  function clear(form) {
    form.querySelectorAll('[data-hod-check-error]').forEach(function (n) {
      n.remove();
    });
    form.querySelectorAll('[data-hod-check-described]').forEach(unmark);
    form.querySelectorAll('[aria-invalid="true"]').forEach(unmark);
    var summary = form.querySelector('[data-hod-check-summary]');
    if (summary) summary.remove();
  }

  function summaryHeading(n) {
    var c = getCopy();
    return n === 1 ? c.summaryOne : String(c.summaryOther || '').replace('2', String(n));
  }

  function goTo(field) {
    field.scrollIntoView({ behavior: 'smooth', block: 'center' });
    field.focus({ preventScroll: true });
  }

  // One problem is solved (a fix button): drop its line, its link, and the
  // summary when nothing is left.
  function resolve(form, problem) {
    if (problem.error) problem.error.remove();
    if (problem.link) problem.link.parentNode.remove();
    unmark(problem.field);
    var summary = form.querySelector('[data-hod-check-summary]');
    if (!summary) return;
    var left = summary.querySelectorAll('li').length;
    if (!left) summary.remove();
    else summary.querySelector('[data-hod-check-heading]').textContent = summaryHeading(left);
  }

  function show(form, problems) {
    clear(form);
    if (!problems.length) return true;
    var c = getCopy();

    var summary = document.createElement('div');
    summary.className = 'hod-errors';
    summary.setAttribute('data-hod-check-summary', '');
    summary.setAttribute('role', 'alert');
    summary.tabIndex = -1;
    var heading = document.createElement('p');
    heading.className = 'hod-errors__heading';
    heading.setAttribute('data-hod-check-heading', '');
    heading.textContent = summaryHeading(problems.length);
    var text = document.createElement('p');
    text.className = 'hod-errors__text';
    text.textContent = problems.length === 1 ? c.summaryTextOne : c.summaryText;
    var list = document.createElement('ul');
    list.className = 'hod-errors__list list-unstyled';
    list.setAttribute('role', 'list');
    summary.appendChild(heading);
    summary.appendChild(text);
    summary.appendChild(list);

    problems.forEach(function (problem) {
      var field = problem.field;
      if (!field.id) field.id = 'HodCheckField-' + ++uid;
      var errorId = field.id + '-error';

      var li = document.createElement('li');
      var link = document.createElement('a');
      link.href = '#' + field.id;
      link.className = 'hod-errors__link';
      link.textContent = labelFor(field) + ' — ' + problem.short;
      link.addEventListener('click', function (e) {
        e.preventDefault();
        goTo(field);
      });
      li.appendChild(link);
      list.appendChild(li);
      problem.link = link;

      var error = document.createElement('div');
      error.className = 'hod-field-error';
      error.id = errorId;
      error.setAttribute('data-hod-check-error', '');
      var line = document.createElement('p');
      line.className = 'hod-field-error__text';
      line.textContent = problem.message;
      error.appendChild(line);
      if (problem.fix) {
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'button hod-field-error__fix';
        button.textContent = problem.fix.label;
        button.addEventListener('click', function () {
          problem.fix.apply();
          resolve(form, problem);
          field.focus();
        });
        error.appendChild(button);
      }
      (problem.container || containerFor(field)).appendChild(error);
      problem.error = error;
      markInvalid(field, errorId);
    });

    var slot = form.querySelector('[data-hod-check-slot]');
    if (slot) slot.appendChild(summary);
    else form.insertBefore(summary, form.firstChild);
    summary.scrollIntoView({ behavior: 'smooth', block: 'start' });
    summary.focus({ preventScroll: true });
    return false;
  }

  // A WhatsApp number. In India (no code, or +91): 10 digits, with spaces,
  // dashes, a +91 / 91 / 0 in front all accepted. Elsewhere: 6 to 14 digits.
  function phone(value, code) {
    var c = getCopy();
    var raw = String(value || '').trim();
    if (!raw) return { message: c.phoneMissing, short: c.missingShort };
    var compact = raw.replace(/[\s\-().]/g, '');
    if (!/^\+?\d+$/.test(compact)) return { message: c.phoneLetters, short: c.phoneLettersShort };
    var prefix = String(code || '').replace(/[^\d+]/g, '');
    if (compact.charAt(0) === '+') {
      if (compact.indexOf('+91') === 0) compact = compact.slice(3);
      else prefix = 'abroad';
      compact = compact.replace(/^\+/, '');
    }
    var abroad = prefix === 'abroad' || (prefix !== '' && prefix !== '+91' && prefix !== '91');
    if (abroad) {
      if (compact.length >= 6 && compact.length <= 14) return null;
      return {
        message: fill(c.phoneDigitsAbroad, { count: compact.length }),
        short: fill(c.phoneShort, { count: compact.length })
      };
    }
    if (compact.length === 12 && compact.indexOf('91') === 0) compact = compact.slice(2);
    if (compact.length === 11 && compact.charAt(0) === '0') compact = compact.slice(1);
    if (compact.length === 10) return null;
    return {
      message: fill(c.phoneDigits, { count: compact.length }),
      short: fill(c.phoneShort, { count: compact.length })
    };
  }

  // A date input holding a day that has gone: offer the next time that day
  // comes round (14 Feb 2025, today 26 Sep 2026 -> 14 February 2027).
  function pastDate(input) {
    var c = getCopy();
    var m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(input.value || '');
    if (!m) return null;
    var month = parseInt(m[2], 10) - 1;
    var day = parseInt(m[3], 10);
    var chosen = new Date(parseInt(m[1], 10), month, day);
    var now = new Date();
    var today = new Date(now.getFullYear(), now.getMonth(), now.getDate());
    if (chosen >= today) return null;
    var next = null;
    for (var y = today.getFullYear(); y < today.getFullYear() + 8; y++) {
      var d = new Date(y, month, day);
      if (d.getMonth() === month && d >= today) {
        next = d;
        break;
      }
    }
    var problem = { field: input, short: c.datePastShort, message: String(c.datePast || '').split('.')[0] + '.' };
    if (!next) return problem;
    var iso = next.getFullYear() + '-' + String(month + 1).padStart(2, '0') + '-' + String(day).padStart(2, '0');
    var words = new Intl.DateTimeFormat('en-GB', { day: 'numeric', month: 'long', year: 'numeric' }).format(next);
    problem.message = fill(c.datePast, { date: words });
    problem.fix = {
      label: fill(c.dateFix, { year: next.getFullYear() }),
      apply: function () {
        input.value = iso;
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
      }
    };
    return problem;
  }

  window.hodFormCheck = {
    copy: getCopy,
    fill: fill,
    show: show,
    clear: clear,
    phone: phone,
    pastDate: pastDate
  };
})();
